import React, { useEffect, useState } from 'react'

import { Avatar, Col, Drawer, Dropdown, Layout as AntdLayout, Menu, Row, Typography, Breadcrumb, } from 'antd'
import { HomeOutlined, LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined, UserOutlined, LockOutlined } from '@ant-design/icons'
import Sidebar from './Sidebar'
import { changePageTitle, titlePage } from './slice'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RootState } from '../../../app/store'
import { LOCAL_STORAGE_TOKEN_ADMIN_CMS, TITLE_NAV, USER_INFO } from '../../../configs/auth'

const { Content, Header } = AntdLayout

type Props = {
  title?: string
  children: React.ReactNode
  sidebarActiveKey?: string
  localAuth?: string[]
  useName: string
}

const DefaultTemplate: React.FC<Props> = ({
  children,
  sidebarActiveKey,
  title, useName,
  localAuth = []

}) => {
  const titleSide = useSelector(titlePage)
  const [collapsed, setCollapse] = useState<boolean>(false)
  const [titles, setTitles] = useState(title)
  // console.log(titles)
  const dispatch = useDispatch()
  const { auth }: any = useSelector((state: RootState) => state.authAdmin)

  const pathname = window.location.pathname.replace("/admin/", "")
  
  const navigate = useNavigate()
  const logout = () => {
    localStorage.removeItem(LOCAL_STORAGE_TOKEN_ADMIN_CMS);
    localStorage.removeItem(USER_INFO);
    localStorage.removeItem(TITLE_NAV);
    navigate('/login-cms')
  }
  useEffect(() => {
    localStorage.getItem(TITLE_NAV) && dispatch(changePageTitle(localStorage.getItem(TITLE_NAV)))
  }, [])
  const menu = (
    <Menu
      items={[
        {
          key: '3',
          icon: <LogoutOutlined />,
          label: <a onClick={() => logout()}>Đăng xuất</a>,
        },
        {
          key: '4',
          icon: <LockOutlined />,
          label: <a onClick={() => navigate("/admin/change-password")}>Đổi mật khẩu</a>,
        },
      ]}
    />
  )
  const [open, setOpen] = useState(false)

  return (
    <>
   
      <AntdLayout style={{ minHeight: '100vh' }}>
        <Sidebar
          localAuth={localAuth}
          activeKey={sidebarActiveKey}
          collapsed={collapsed}
          setCollapse={setCollapse}
          setTitle={setTitles}
          title={titles ?? ''}
        />
        
        <AntdLayout className="site-layout">
          <Header
            className="layout-header"
            style={{ marginLeft: collapsed ? 82 : 200 }}
          >

            <Row>
              <Col span={24}>
                <Row align="middle" gutter={[10, 10]}>
                  <Col>
                    {React.createElement(
                      collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                      {
                        className: 'trigger collapsed-icon',
                        onClick: () => setCollapse(!collapsed),
                      }
                    )}
                  </Col>
                  <Col>
                    {/* <Typography.Title level={4} className='flex items-center !mb-[0]'>{titleSide}</Typography.Title> */}
                    <Breadcrumb>
                      <Breadcrumb.Item href="">
                        <HomeOutlined />
                      </Breadcrumb.Item>
                      <Breadcrumb.Item>
                        <UserOutlined />
                        <span>Admin</span>
                      </Breadcrumb.Item>
                      <Breadcrumb.Item><span>{titleSide}</span></Breadcrumb.Item>
                    </Breadcrumb>
                  </Col>
                  <Col style={{ position: 'absolute', top: '0', right: '0' }}>
                    <div className='flex justify-center items-center cursor-pointer'>
                      <span className='mr-[10px] text-[16px]'>{useName}</span>
                      <Dropdown overlay={menu} placement="topRight">
                        <Avatar size={40} icon={<UserOutlined />} />
                      </Dropdown>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Header>
          <Content
            style={{ marginLeft: collapsed ? 82 : 190 }}
            className="layout-content"
          >
            <div>{children}</div>
           
          </Content>
        </AntdLayout>
      </AntdLayout>
      <Drawer
        title="Change Password"
        placement="right"
        onClose={() => setOpen(false)}
        width={500}
        open={open}
      >
      </Drawer>
    </>
  )
}

export default DefaultTemplate
